import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {INotificacion, IParcela} from "../../../types";
import {Paper, Typography, Button, TextField} from "@material-ui/core";

import {userService} from "../../../services/UserService";
import {LatLngTuple} from "leaflet";
import {Image} from "@material-ui/icons";
import ETcData from "./ETcData";
import CustomData from "./CustomData";


const config = require('../../../config.json');
const texts = require('../../../texts/subirdatos.json');


interface IProps {
    parcela: IParcela
    menu: boolean
    idioma: string
}

interface Istate {
    text: Record<string, string>
}

class SubirDatos extends React.Component<IProps, Istate> {

    state:Istate = {
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    render() {
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#eee',
                    overflow: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: this.props.menu? '18%': '5%',
                        width: this.props.menu? '82%': '95%',
                        height: '100%',
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: "100%",
                            width: "90%",
                        }}
                    >
                        <Typography
                            style={{
                                marginTop: 40,
                                marginLeft: 20,
                                marginBottom: 50,
                                fontSize: 24,
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["0"]} {this.props.parcela['nombre']}
                        </Typography>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "100%",
                                height: "100%",
                                justifyContent: "space-between"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: '45%',
                                    height: '100%'
                                }}
                            >
                                <ETcData/>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: '45%',
                                    height: '100%'
                                }}
                            >
                                <CustomData/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    parcela: state.subirDatos.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(SubirDatos);
